<ng-container>
  @if (!withConfirmation || (withConfirmation && openModalIsBottom())) {
    @if (openModalIsBottom()) {
      <button
        type="button"
        class="btn btn-secondary btn-inverse"
        [ecmDisabledAction]="isDisabledEclair()"
        (click)="openModal(!isXsScreen ? webModal : null)"
      >
        {{ openModalTitle() }}
      </button>
    } @else {
      <button
        class="ob1-link-icon"
        [class.ob1-link-icon--vertical]="isVerticalLayout()"
        type="button"
        [style.color]="openModalColor()"
        [ecmDisabledAction]="isDisabledEclair()"
        (click)="openModal(!isXsScreen ? webModal : null)"
      >
        <span class="icon" [ngClass]="openModalIcon()" aria-hidden="true"></span>
        <span class="ob1-link-icon-text">{{ openModalTitle() }}</span>
      </button>
    }
  }

  <!-- snackbar réutilisable -->
  <ng-template #snackbarTemplate let-show="show">
    <output
      id="snackbar-link-banner"
      [ngClass]="{
        'ob1-snackbar': true,
        show: show,
      }"
      aria-live="polite"
      aria-atomic="true"
      [attr.data-e2e]="e2e"
    >
      <div class="ob1-snackbar-wrapper">
        <span class="ob1-snackbar-icon icon-tick-circle" aria-hidden="true"></span>
        <p class="ob1-snackbar-label">{{ i18nPath + '.snackbar.text' | translate }}</p>
      </div>
    </output>
  </ng-template>

  <!--  web modale-->
  <ng-template #webModal>
    <div class="modal-header d-sm-none d-md-block">
      <button
        type="button"
        class="close"
        [attr.aria-label]="i18nPath + '.bottomTitle' | translate"
        (click)="closeWebModal()"
      >
        <span class="icon icon-delete" aria-hidden="true"></span>
      </button>
      <button
        type="button"
        class="close o-link-arrow back"
        [attr.aria-label]="i18nPath + '.bottomTitle' | translate"
        (click)="closeWebModal()"
      >
        {{ i18nPath + '.bottomTitle' | translate }}
      </button>
    </div>
    <div class="modal-body">
      @if (isLoading()) {
        <h4 class="mb-1">{{ openModalTitle() }}</h4>
        <div class="text-center py-1">
          <div class="container-fluid">
            <ecm-mat-spinner [centered]="true"></ecm-mat-spinner>
          </div>
          <p class="lead mt-2 mb-0">{{ i18nPath + '.loading.text' | translate }}</p>
        </div>
      } @else if (isError()) {
        <h4 class="mb-1">{{ openModalTitle() }}</h4>
        <div class="text-center pt-1">
          <span class="icon icon-error-severe text-critical" style="font-size: 64px" aria-hidden="true"></span>
          <p class="mt-1 mb-0 pb-0 lead">{{ errorTitle() || (i18nPath + '.error.title' | translate) }}</p>
          <p class="standard mb-0 text-gray3">{{ errorText() || (i18nPath + '.error.text' | translate) }}</p>
        </div>
      } @else if (withConfirmation) {
        <h4 class="pt-0 pt-sm-2 pt-md-0">{{ confirmation().title }}</h4>
        <p [innerHTML]="confirmation().description"></p>
      } @else {
        @if (!qrCodeUrl()) {
          <h4 class="mb-1">{{ openModalTitle() }}</h4>
        }
        @if (!qrCodeUrl() && withOfferSection) {
          <ecm-mat-bottom-sheet-offer-section [offerSection]="offerSection()"></ecm-mat-bottom-sheet-offer-section>
        }
        @if (!qrCodeUrl() && withLinks) {
          <ecm-mat-bottom-sheet-link-items
            [items]="linkItems()"
            (clickLink)="clickLink.emit($event)"
          ></ecm-mat-bottom-sheet-link-items>
        }
        @if (qrCodeUrl() && withQrCode) {
          <ecm-mat-bottom-sheet-qr-code [qrCodeUrl]="qrCodeUrl()"></ecm-mat-bottom-sheet-qr-code>
        }
      }

      <!-- snackbar section -->
      <ng-container
        *ngTemplateOutlet="snackbarTemplate; context: { show: !isOffcanvasOpen && displaySnack() }"
      ></ng-container>
    </div>
    <div class="modal-footer mt-1">
      @if (isLoading() || isError()) {
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          [attr.aria-label]="i18nPath + '.bottomTitle' | translate"
          (click)="closeWebModal()"
        >
          {{ i18nPath + '.bottomTitle' | translate }}
        </button>
      } @else if (withConfirmation) {
        <div
          class="confirmation-buttons d-flex flex-column-reverse flex-sm-row justify-content-center align-items-center"
        >
          @if (confirmation().secondaryButton) {
            <button
              type="button"
              class="btn btn-secondary"
              [attr.data-e2e]="e2e + '-btn-cancel'"
              (click)="onSecondaryButtonClick()"
            >
              {{ confirmation().secondaryButton.label }}
            </button>
          }
          @if (confirmation().primaryButton) {
            <button
              type="button"
              class="btn btn-primary ml-sm-2 ml-0 mb-sm-0 mb-1"
              [attr.data-e2e]="e2e + '-btn-confirm'"
              (click)="onPrimaryButtonClick()"
            >
              {{ confirmation().primaryButton.label }}
            </button>
          }
        </div>
      } @else {
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          [attr.aria-label]="i18nPath + '.bottomTitle' | translate"
          (click)="closeWebModal()"
        >
          {{ i18nPath + '.bottomTitle' | translate }}
        </button>
      }
    </div>
  </ng-template>

  <!-- mobile modale -->
  <ng-container>
    <div
      class="modal-backdrop-custom"
      [class.show]="isOffcanvasOpen"
      (click)="closeMobileModal()"
      (keydown)="onBackdropKeyDown($event)"
    ></div>
    <dialog
      #mobileOffcanvas
      class="offcanvas-bottom-custom"
      [class.show]="isOffcanvasOpen"
      [open]="isOffcanvasOpen"
      (click)="$event.stopPropagation()"
      [attr.data-e2e]="e2e"
      (keydown)="onOffcanvasKeyDown($event)"
      tabindex="-1"
      aria-modal="true"
      style="border: none; padding: 0; margin: 0; max-width: 100%; color: inherit; font: inherit"
    >
      <!-- Handle pour le swipe down -->
      <button
        type="button"
        class="swipe-handle"
        (touchstart)="onSwipeHandleTouchStart($event)"
        (touchmove)="onSwipeHandleTouchMove($event)"
        (touchend)="onSwipeHandleTouchEnd()"
        (keydown)="onSwipeHandleTouchEnd()"
        aria-label="Glisser vers le bas pour fermer"
        style="
          border: none;
          background: transparent;
          width: 100%;
          appearance: none;
          -webkit-appearance: none;
          font: inherit;
          color: inherit;
          margin: 0;
          padding: 0;
        "
      >
        <div class="swipe-handle-bar" aria-hidden="true"></div>
      </button>
      <button type="button" class="close mr-0 mt-0" (click)="closeMobileModal()" aria-label="Fermer"></button>

      @if (isLoading() || isError()) {
        <div class="modal-header mx-1 px-0">
          <h3 class="mb-0 mt-1">{{ openModalTitle() }}</h3>
        </div>
      } @else if (withConfirmation) {
        <div class="modal-header mx-1 px-0">
          <h4 class="mb-0 mt-1">{{ confirmation().title }}</h4>
        </div>
      } @else if (!qrCodeUrl()) {
        <div class="modal-header mx-1 px-0">
          <h3 class="mb-0 mt-1">{{ openModalTitle() }}</h3>
        </div>
      }

      <div
        class="modal-body mx-1"
        [ngClass]="{ 'mt-1': qrCodeUrl() && !withConfirmation && !isLoading() && !isError() }"
      >
        @if (isLoading()) {
          <div class="text-center py-1">
            <div class="container-fluid">
              <ecm-mat-spinner [centered]="true"></ecm-mat-spinner>
            </div>
            <p class="lead mt-2 mb-0">{{ i18nPath + '.loading.text' | translate }}</p>
          </div>
          <div class="d-flex justify-content-center mb-3">
            <button type="button" class="btn btn-secondary" (click)="closeMobileModal()">
              {{ i18nPath + '.bottomTitle' | translate }}
            </button>
          </div>
        } @else if (isError()) {
          <div class="text-center pt-1">
            <span class="icon icon-error-severe text-critical" style="font-size: 64px" aria-hidden="true"></span>
            <p class="mt-1 mb-0 pb-0 lead">{{ errorTitle() || (i18nPath + '.error.title' | translate) }}</p>
            <p class="standard mb-0 text-gray3">{{ errorText() || (i18nPath + '.error.text' | translate) }}</p>
          </div>
          <div class="d-flex justify-content-center mb-3">
            <button type="button" class="btn btn-secondary" (click)="closeMobileModal()">
              {{ i18nPath + '.bottomTitle' | translate }}
            </button>
          </div>
        } @else if (withConfirmation) {
          <p [innerHTML]="confirmation().description"></p>
          <div class="confirmation-buttons d-flex flex-column align-items-center mt-2">
            @if (confirmation().primaryButton) {
              <button
                type="button"
                class="btn btn-primary mb-2"
                [attr.data-e2e]="e2e + '-btn-confirm'"
                (click)="onPrimaryButtonClickMobile()"
              >
                {{ confirmation().primaryButton.label }}
              </button>
            }
            @if (confirmation().secondaryButton) {
              <button
                type="button"
                class="btn btn-secondary mb-2"
                [attr.data-e2e]="e2e + '-btn-cancel'"
                (click)="onSecondaryButtonClickMobile()"
              >
                {{ confirmation().secondaryButton.label }}
              </button>
            }
          </div>
        } @else {
          @if (!qrCodeUrl() && withOfferSection) {
            <ecm-mat-bottom-sheet-offer-section [offerSection]="offerSection()"></ecm-mat-bottom-sheet-offer-section>
          }
          @if (!qrCodeUrl() && withLinks) {
            <ecm-mat-bottom-sheet-link-items [items]="linkItems()" (clickLink)="clickLink.emit($event)">
            </ecm-mat-bottom-sheet-link-items>
          }
          @if (qrCodeUrl() && withQrCode) {
            <ecm-mat-bottom-sheet-qr-code [qrCodeUrl]="qrCodeUrl()"></ecm-mat-bottom-sheet-qr-code>
          }
        }
        <ng-container
          *ngTemplateOutlet="snackbarTemplate; context: { show: isOffcanvasOpen && displaySnack() }"
        ></ng-container>
      </div>
    </dialog>
  </ng-container>
</ng-container>
